import App from "@frog/source/models/App.js"
import Zone from "@frog/source/models/Zone.js"
import World from "@frog/source/models/World.js"

import pixel from "@frog/source/views/utility/pixel.js"
import {getImageFromAnimation} from "@frog/source/juice/utility/getFrameFromAnimation.js"
import {getTime} from "@frog/source/juice/utility/Time.js"

// const standardCursorAnimation = require("@frog/source/assets/images/hero-tactics/ui/fe-cursor/standard/animation.js")
// const staticCursorImage = require("@frog/source/assets/images/ninja-tactics/iso-pass/cursor.png").default
const staticCursorImage = require("@frog/source/assets/images/apocalypse-tactics/ui/cursor.png").default

export default function Cursor(stage) {
    if(stage == undefined) {
        return
    }
    if(App.game.encounter.selection.position.z == 0) {
        return
    }
    if(World.isOutOfBounds(stage.world, App.game.encounter.selection.position)) {
        return
    }

    if(Zone.isInBounds(stage.encounters[stage.currentEncounter || 1].zone, App.game.encounter.selection.position) == false) {
        return
    }

    if(World.isEmptyPosition(stage.world, App.game.encounter.selection.position)) {
        App.game.encounter.selection.cursor = {}
        return
    }


    // let image = getImageFromAnimation(standardCursorAnimation, getTime().ms - App.game.encounter.selection.hoveredTime)
    // if(App.game.encounter.selection.hoveredUnitKey != undefined) {
    //     image = require("@frog/source/assets/images/hero-tactics/ui/fe-cursor/big.png").default
    // }

    const selection = App.game.encounter.selection

    selection.cursor = selection.cursor || {}
    const cursor = selection.cursor
    cursor.position = cursor.position || {}

    const SPEED = 0.66
    const MIN_DELTA = 0.1

    cursor.position.x = cursor.position.x ?? selection.position.x
    cursor.position.x -= (cursor.position.x - selection.position.x) * SPEED
    if(Math.abs(selection.position.x - cursor.position.x) < MIN_DELTA) {
        cursor.position.x = selection.position.x
    }

    cursor.position.y = cursor.position.y ?? selection.position.y
    cursor.position.y -= (cursor.position.y - selection.position.y) * SPEED
    if(Math.abs(selection.position.y - cursor.position.y) < MIN_DELTA) {
        cursor.position.y = selection.position.y
    }

    cursor.position.z = cursor.position.z ?? selection.position.z
    // cursor.position = {x: 0, y: 0, z: 1}

    let image = staticCursorImage

    return [
        {
            "key": "cursor",
            "image": image,
            // "stack": 10000,
            "anchor": {"x": "50%", "y": "100%"},
            "position": pixel("cursor", {
                "x": cursor.position.x,
                "y": cursor.position.y,
                "z": cursor.position.z
            }),
        },
        // App.game.encounter.selection.selectedUnit != undefined && {
        //     "key": "cursor-pointer",
        //     "image": require("@frog/source/assets/images/leviathan-tactics/ui/cursor/pointer.png").default,
        //     "anchor": {"x": "50%", "y": "100%"},
        //     "position": pixel("cursor", {
        //         "x": App.game.encounter.selection.selectedUnit.position.x,
        //         "y": App.game.encounter.selection.selectedUnit.position.y,
        //         "z": App.game.encounter.selection.selectedUnit.position.z + 2,
        //     }),
        // },
    ]
}
